/* Naguirre — frete igual ao do checkout (03/10/2026). Usado pela página do produto e pela gaveta.

   COMO CALCULA: monta um carrinho SEPARADO na Storefront API (sem token) com as peças do carrinho
   da cliente (+ a peça da página, no produto) e o CEP, e lê as opções que o checkout mostraria:
   - tarifas do Frenet (deliveryGroups com withCarrierRates, que exige @defer);
   - prazo "N dias úteis", no mesmo texto do checkout (deliveryPromise, que só existe na versão
     unstable da API; se ela recusar, a consulta cai para a 2026-07 e mostra só o preço);
   - desconto de frete (automático "Frete Grátis": mínimo R$ 249 e teto R$ 40; ou cupom de frete):
     escolhe uma opção nesse carrinho separado e lê o desconto que a própria Shopify aplicou.
   Conferido em 03/10 com 4 carrinhos x 4 CEPs (SP, Campinas, Manaus, Recife): mesmos valores e
   prazos do checkout, inclusive a faixa de R$ 9,90 e o grátis acima de R$ 249.

   POR QUE NUM WEB WORKER: o simulador antigo fazia /cart/add.js num carrinho falso, e cada consulta
   virava "adicionou ao carrinho" na Meta, no GA4 e no Ledger. Aqui nada passa pelo fetch da página
   (que o Web Pixels Manager, o rastreio da Shopify e os apps de cupom/brinde observam) e o carrinho
   da cliente não muda (a Storefront API vai sem cookies). Se o navegador não criar o Worker, a
   reserva usa o endereço sem ".json", que o monitor de carrinho da Shopify não observa.
   Tarifas: dois apps (Frenet: Jadlog e Sedex; Mandaê: Econômico e Rápido). */
(function () {
  'use strict';
  if (window.NaguirreFrete) return;

  var VERSAO_COM_PRAZO = 'unstable';
  var VERSAO_ESTAVEL = '2026-07';
  var CHAVE_CEP = 'ngCep';
  var TEMPO_MAXIMO = 20000;
  // Naguirre 04/10/2026: falha de rede mostrava a frase do navegador, em inglês ("Failed to fetch").
  var SEM_CONEXAO = 'Não conseguimos falar com a loja agora. Confira sua internet e tente de novo.';
  // 04/10/2026: depois de muitas consultas seguidas, a Shopify respondeu por um tempo "Carrier-calculated
  // rates through @defer is temporarily unavailable" (tarifas das transportadoras por este caminho fora do
  // ar). Não é problema de versão da API: a sessão não troca para a versão sem prazo por causa disso.
  var INDISPONIVEL = 'O cálculo do frete está indisponível agora. Tente de novo em instantes; o valor certo aparece no checkout.';
  function tipoDoErro(erros) {
    var msgs = (erros || []).map(function (x) { return String((x && x.message) || ''); }).join(' | ');
    if (/unavailable/i.test(msgs)) return 'indisponivel';
    return erros && erros.length ? 'versao' : 'rede';
  }
  var versaoAtual = VERSAO_COM_PRAZO;

  // ---------- CEP ----------
  function soDigitos(v) { return String(v || '').replace(/\D/g, '').slice(0, 8); }
  function mascara(v) { var d = soDigitos(v); return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; }

  // UF pela faixa de CEP dos Correios (o endereço do carrinho leva a UF junto com o CEP).
  var FAIXAS = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
    [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];
  function ufDoCep(cep) {
    var n = parseInt(soDigitos(cep).slice(0, 5), 10);
    for (var i = 0; i < FAIXAS.length; i++) if (n >= FAIXAS[i][0] && n <= FAIXAS[i][1]) return FAIXAS[i][2];
    return '';
  }

  function lerCep() { try { return localStorage.getItem(CHAVE_CEP) || ''; } catch (e) { return ''; } }
  function gravarCep(v) { try { localStorage.setItem(CHAVE_CEP, soDigitos(v)); } catch (e) {} }
  // A cliente calculou o frete nesta visita (aba): a gaveta passa a mostrar o total com frete e a
  // refazer a conta quando a sacola muda. O CEP guardado sozinho (de outra visita) não liga isso.
  var CHAVE_CALCULOU = 'ngFreteCalculou';
  function marcarCalculou() { try { sessionStorage.setItem(CHAVE_CALCULOU, '1'); } catch (e) {} }
  function jaCalculou() { try { return sessionStorage.getItem(CHAVE_CALCULOU) === '1'; } catch (e) { return false; } }

  function centavos(valor) { return Math.round(parseFloat(valor || 0) * 100); }
  function dinheiro(c) {
    try { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
  }
  function escapar(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function erro(mensagem, tipo) { var e = new Error(mensagem); e.tipo = tipo; return e; }

  // ---------- Transporte: Web Worker ----------
  // Tudo passa por um Worker: o fetch dele não é o da página, então nem o Web Pixels Manager nem os
  // apps de cupom/brinde (que embrulham o fetch da página e reagem a /cart.js) enxergam as chamadas.
  // Storefront API: sem cookies (carrinho separado). Leitura do carrinho e endereço: com os cookies
  // da loja (é o carrinho da própria cliente, só leitura).
  var FONTE_WORKER = [
    'self.onmessage = function (e) {',
    '  var d = e.data;',
    '  var h = { "Accept": d.accept };',
    '  if (d.corpo) h["Content-Type"] = "application/json";',
    '  fetch(d.url, { method: d.metodo, credentials: d.credenciais, cache: "no-store", headers: h, body: d.corpo || undefined })',
    '  .then(function (r) { return r.text().then(function (t) {',
    '    self.postMessage({ id: d.id, status: r.status, tipo: r.headers.get("content-type") || "", texto: t }); }); })',
    '  .catch(function (err) { self.postMessage({ id: d.id, erro: String((err && err.message) || err) }); });',
    '};'
  ].join('\n');
  var trabalhador = null; // null = ainda não criado; false = indisponível neste navegador
  var pendentes = {};
  var sequencia = 0;

  function obterTrabalhador() {
    if (trabalhador !== null) return trabalhador;
    try {
      trabalhador = new Worker(URL.createObjectURL(new Blob([FONTE_WORKER], { type: 'text/javascript' })));
      trabalhador.onmessage = function (ev) {
        var d = ev.data || {};
        var fim = pendentes[d.id];
        if (fim) { delete pendentes[d.id]; fim(d); }
      };
      trabalhador.onerror = function () {
        trabalhador = false;
        Object.keys(pendentes).forEach(function (id) { var fim = pendentes[id]; delete pendentes[id]; fim({ erro: 'worker' }); });
      };
    } catch (e) { trabalhador = false; }
    return trabalhador;
  }

  /* pedido: { caminho, metodo, corpo, accept, credenciais, soNoWorker }
     soNoWorker: sem Worker, não faz (usado no que só serve de bônus, como gravar o CEP). */
  function pedir(pedido) {
    var url = location.origin + pedido.caminho;
    return new Promise(function (ok, falha) {
      function pelaPagina() {
        if (pedido.soNoWorker) { falha(erro('sem worker', 'rede')); return; }
        var h = { Accept: pedido.accept };
        if (pedido.corpo) h['Content-Type'] = 'application/json';
        fetch(url, { method: pedido.metodo, credentials: pedido.credenciais, cache: 'no-store', headers: h, body: pedido.corpo || undefined })
          .then(function (r) { return r.text().then(function (t) { ok({ status: r.status, tipo: r.headers.get('content-type') || '', texto: t }); }); })
          .catch(function () { falha(erro(SEM_CONEXAO, 'rede')); });
      }
      var w = obterTrabalhador();
      if (!w) { pelaPagina(); return; }
      var id = ++sequencia;
      var relogio = setTimeout(function () { delete pendentes[id]; falha(erro('Demorou demais para responder.', 'rede')); }, TEMPO_MAXIMO);
      pendentes[id] = function (r) {
        clearTimeout(relogio);
        if (r.erro === 'worker') { pelaPagina(); return; }
        if (r.erro) { falha(erro(SEM_CONEXAO, 'rede')); return; }
        ok(r);
      };
      w.postMessage({ id: id, url: url, metodo: pedido.metodo, corpo: pedido.corpo || null, accept: pedido.accept, credenciais: pedido.credenciais });
    }).then(function (r) {
      if (r.status === 429) throw erro('Muitas consultas agora. Tente de novo em instantes.', 'ocupado');
      return r;
    });
  }

  function lerResposta(r) {
    var partes = [];
    if (r.tipo.indexOf('multipart') === -1) {
      partes.push(JSON.parse(r.texto));
    } else {
      var m = /boundary="?([^";]+)"?/i.exec(r.tipo);
      r.texto.split('--' + (m ? m[1] : 'graphql')).forEach(function (bloco) {
        var i = bloco.indexOf('{');
        var j = bloco.lastIndexOf('}');
        if (i === -1 || j < i) return;
        try { partes.push(JSON.parse(bloco.slice(i, j + 1))); } catch (e) {}
      });
    }
    // Junta a parte inicial com as partes adiadas (@defer), cada uma no caminho que ela indica.
    var dados = null;
    var erros = [];
    partes.forEach(function (p) {
      if (p.errors) erros = erros.concat(p.errors);
      if (p.data) dados = p.data;
      (p.incremental || []).forEach(function (inc) {
        if (inc.errors) erros = erros.concat(inc.errors);
        if (!inc.data || !dados) return;
        var alvo = dados;
        (inc.path || []).forEach(function (k) { if (alvo) alvo = alvo[k]; });
        if (alvo) Object.keys(inc.data).forEach(function (k) { alvo[k] = inc.data[k]; });
      });
    });
    return { dados: dados, erros: erros };
  }

  // Storefront API, sem cookies. Endereço sem ".json": o monitor de carrinho da Shopify só observa
  // /api/<versão>/graphql.json (vale para a reserva sem Worker).
  function enviar(versao, consulta, variaveis, adiada) {
    return pedir({
      caminho: '/api/' + versao + '/graphql',
      metodo: 'POST',
      corpo: JSON.stringify({ query: consulta, variables: variaveis || {} }),
      accept: adiada ? 'multipart/mixed; deferSpec=20220824, application/json' : 'application/json',
      credenciais: 'omit'
    }).then(function (r) {
      if (r.status !== 200) throw erro('Não foi possível calcular agora (' + r.status + ').', 'rede');
      try { return lerResposta(r); } catch (e) { throw erro('Não foi possível calcular agora. Tente de novo em instantes.', 'rede'); }
    });
  }

  // ---------- Consultas ----------
  var CRIAR = 'mutation($i: CartInput!) { cartCreate(input: $i) { cart { id cost { subtotalAmount { amount } } } userErrors { field message code } } }';
  function consultaFrete(comPrazo) {
    return 'query($id: ID!) { cart(id: $id) { id ... @defer(label: "frete") { deliveryGroups(first: 5, withCarrierRates: true) { nodes { id deliveryOptions { handle title estimatedCost { amount }' +
      (comPrazo ? ' deliveryPromise' : '') + ' } } } } } }';
  }
  var ESCOLHER = 'mutation($id: ID!, $s: [CartSelectedDeliveryOptionInput!]!) { cartSelectedDeliveryOptionsUpdate(cartId: $id, selectedDeliveryOptions: $s) { cart { discountAllocations { discountedAmount { amount } targetType } } userErrors { message } } }';

  /* pedido: { linhas: [{ id: variante, quantidade }], cep, codigos: [cupons do carrinho],
               gratisMin: centavos (mínimo do desconto "Frete Grátis"), gratisTeto: centavos (teto dele) }
     devolve: { opcoes: [{ nome, centavos, original, gratis, prazo }], subtotal, cep } */
  function cotar(pedido) {
    var cep = soDigitos(pedido.cep);
    if (cep.length !== 8) return Promise.reject(erro('Digite os 8 números do CEP.', 'cep'));
    var linhas = (pedido.linhas || []).filter(function (l) { return l.id && l.quantidade > 0; }).map(function (l) {
      return { merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: l.quantidade };
    });
    if (!linhas.length) return Promise.reject(erro('Escolha uma peça para calcular o frete.', 'vazio'));
    var codigos = pedido.codigos || [];
    var entrada = {
      lines: linhas,
      delivery: { addresses: [{ address: { deliveryAddress: { zip: mascara(cep), countryCode: 'BR', provinceCode: ufDoCep(cep) } }, selected: true, oneTimeUse: true }] }
    };
    if (codigos.length) entrada.discountCodes = codigos;

    function tentar(versao) {
      return enviar(versao, CRIAR, { i: entrada }, false).then(function (r) {
        var res = r.dados && r.dados.cartCreate;
        if (!res || !res.cart) {
          // A Shopify responde em inglês (ex.: peça esgotada); para a cliente, uma frase só.
          if (window.console) console.warn('[NaguirreFrete] cartCreate', (res && res.userErrors) || r.erros);
          throw erro('Não foi possível calcular agora. Confira o tamanho escolhido e tente de novo.', r.erros.length ? 'versao' : 'carrinho');
        }
        var carrinho = res.cart;
        var subtotal = centavos(carrinho.cost.subtotalAmount.amount);
        return enviar(versao, consultaFrete(versao === VERSAO_COM_PRAZO), { id: carrinho.id }, true).then(function (f) {
          var grupos = f.dados && f.dados.cart && f.dados.cart.deliveryGroups;
          if (!grupos) {
            var tipo = tipoDoErro(f.erros);
            throw erro(tipo === 'indisponivel' ? INDISPONIVEL : 'Não foi possível calcular agora. Tente de novo em instantes.', tipo);
          }
          var grupo = grupos.nodes && grupos.nodes[0];
          var opcoes = grupo ? grupo.deliveryOptions.map(function (o) {
            var c = centavos(o.estimatedCost && o.estimatedCost.amount);
            return { handle: o.handle, nome: o.title, centavos: c, original: c, gratis: false, prazo: o.deliveryPromise || '' };
          }) : [];
          opcoes.sort(function (a, b) { return a.original - b.original; });
          var pronto = { opcoes: opcoes, subtotal: subtotal, cep: cep };
          // O grátis automático só existe a partir do mínimo; um cupom de frete ("-FRETE") vale sem mínimo.
          var podeSerGratis = codigos.length > 0 || (pedido.gratisMin > 0 && subtotal >= pedido.gratisMin);
          if (!opcoes.length || !podeSerGratis) return pronto;

          // Confirma com a própria Shopify: escolhe uma opção neste carrinho separado e lê o desconto de
          // frete que ela aplicou (cobre a regra automática, cupom de frete e mudanças no admin).
          function freteZerado(opcao) {
            if (opcao.original === 0) return Promise.resolve(true);
            return enviar(versao, ESCOLHER, { id: carrinho.id, s: [{ deliveryGroupId: grupo.id, deliveryOptionHandle: opcao.handle }] }, false)
              .then(function (s) {
                var res2 = s.dados && s.dados.cartSelectedDeliveryOptionsUpdate;
                if (!res2 || !res2.cart) return null; // sem resposta: decide pela regra do tema
                var desconto = 0;
                (res2.cart.discountAllocations || []).forEach(function (a) {
                  if (a.targetType === 'SHIPPING_LINE') desconto += centavos(a.discountedAmount.amount);
                });
                return desconto >= opcao.original;
              }, function () { return null; });
          }
          function marcar(ateQuanto) { // zera as opções até esse valor (Infinity = todas)
            opcoes.forEach(function (o) {
              if (o.original > 0 && o.original <= ateQuanto) { o.gratis = true; o.centavos = 0; }
            });
            return pronto;
          }
          var teto = pedido.gratisTeto > 0 ? pedido.gratisTeto : Infinity;
          var regraDoTema = !codigos.length && subtotal >= pedido.gratisMin;
          var barata = opcoes[0];
          var cara = opcoes[opcoes.length - 1];
          return freteZerado(barata).then(function (zerou) {
            if (zerou === null) return regraDoTema ? marcar(teto) : pronto;
            if (!zerou) return pronto;
            // A mais barata saiu grátis. Se há opção acima do teto do desconto automático, confere a mais
            // cara: um cupom de frete sem teto zera todas; o automático só as de até R$ 40.
            if (cara.original <= teto || cara === barata) return marcar(teto);
            return freteZerado(cara).then(function (zerouCara) { return marcar(zerouCara ? Infinity : teto); });
          });
        });
      });
    }

    return tentar(versaoAtual).catch(function (e) {
      if (e && e.tipo === 'versao' && versaoAtual !== VERSAO_ESTAVEL) {
        versaoAtual = VERSAO_ESTAVEL; // a versão com prazo recusou: segue sem o prazo
        return tentar(VERSAO_ESTAVEL);
      }
      throw e;
    });
  }

  // Peças do carrinho da cliente (só leitura, pelo Worker). O brinde automático (Dr Free Gift, preço
  // zero) fica de fora: não muda o valor e o produto dele é oculto. Os cupons aplicados vão junto.
  function lerCarrinho() {
    return pedir({ caminho: '/cart.js', metodo: 'GET', accept: 'application/json', credenciais: 'same-origin' })
      .then(function (r) {
        if (r.status !== 200) throw erro('carrinho ' + r.status, 'rede');
        var c = JSON.parse(r.texto);
        var linhas = [];
        (c.items || []).forEach(function (i) {
          var p = i.properties || {};
          if (p['Gift ID '] || p['Gift ID'] || (i.original_line_price === 0 && i.final_line_price === 0)) return;
          linhas.push({ id: i.variant_id, quantidade: i.quantity });
        });
        var codigos = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        // Todos os cupons do carrinho (o Liquid só enxerga os que já descontam nas peças; cupom de frete fica de fora).
        // nasPecas: o cupom desconta em alguma peça (ou no carrinho todo); se não, é cupom de frete.
        var nasPecas = {};
        (c.cart_level_discount_applications || []).forEach(function (a) {
          if (a && a.type === 'discount_code' && a.title) nasPecas[String(a.title).toLowerCase()] = true;
        });
        (c.items || []).forEach(function (i) {
          (i.line_level_discount_allocations || []).forEach(function (al) {
            var a = al && al.discount_application;
            if (a && a.type === 'discount_code' && a.title) nasPecas[String(a.title).toLowerCase()] = true;
          });
        });
        var cupons = (c.discount_codes || []).map(function (d) {
          return { code: String(d.code), applicable: !!d.applicable, nasPecas: !!nasPecas[String(d.code).toLowerCase()] };
        });
        return { linhas: linhas, codigos: codigos, cupons: cupons, itens: c.item_count || 0, total: c.total_price };
      });
  }

  // Bônus: grava o CEP (e a UF) no carrinho da cliente, para o checkout já abrir com eles preenchidos.
  // É a mesma consulta de tarifas que o tema antigo fazia; só pelo Worker, e só com carrinho cheio.
  function gravarCepNoCarrinho(cep) {
    var d = soDigitos(cep);
    if (d.length !== 8) return;
    pedir({
      caminho: '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + encodeURIComponent(mascara(d)) +
        '&shipping_address%5Bcountry%5D=Brazil&shipping_address%5Bprovince%5D=' + encodeURIComponent(ufDoCep(d)),
      metodo: 'GET', accept: 'application/json', credenciais: 'same-origin', soNoWorker: true
    }).catch(function () {});
  }

  // Reserva da gaveta quando a Shopify recusa o caminho acima ("indisponivel"): tarifas do carrinho da própria
  // cliente pela rota antiga (/cart/shipping_rates.json, a do tema anterior; não é "adicionar ao carrinho",
  // nenhum rastreador vê, e funcionou durante a recusa de 04/10). Traz preço e prazo, sem descontos: o grátis
  // automático segue a regra da loja (mínimo e teto); cupom de frete, só no checkout.
  // pedido: { cep, subtotal (centavos, depois das promoções), gratisMin, gratisTeto }
  function prazoDias(dias) {
    if (!dias || !dias.length || !(dias[0] > 0)) return '';
    var a = dias[0], b = dias[dias.length - 1];
    return (b > a ? a + ' a ' + b : String(a)) + (b > 1 ? ' dias úteis' : ' dia útil');
  }
  function cotarPeloCarrinho(pedido) {
    var d = soDigitos(pedido.cep);
    if (d.length !== 8) return Promise.reject(erro('Digite os 8 números do CEP.', 'cep'));
    return pedir({
      caminho: '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + encodeURIComponent(mascara(d)) +
        '&shipping_address%5Bcountry%5D=Brazil&shipping_address%5Bprovince%5D=' + encodeURIComponent(ufDoCep(d)),
      metodo: 'GET', accept: 'application/json', credenciais: 'same-origin', soNoWorker: true
    }).then(function (r) {
      if (r.status !== 200) throw erro(INDISPONIVEL, 'indisponivel');
      var tarifas = (JSON.parse(r.texto).shipping_rates || []);
      var opcoes = tarifas.map(function (t) {
        var c = centavos(t.price);
        return { handle: t.code, nome: t.presentment_name || t.name, centavos: c, original: c, gratis: false, prazo: prazoDias(t.delivery_days) };
      });
      opcoes.sort(function (a, b) { return a.original - b.original; });
      var subtotal = pedido.subtotal || 0;
      if (pedido.gratisMin > 0 && subtotal >= pedido.gratisMin) {
        var teto = pedido.gratisTeto > 0 ? pedido.gratisTeto : Infinity;
        opcoes.forEach(function (o) { if (o.original > 0 && o.original <= teto) { o.gratis = true; o.centavos = 0; } });
      }
      return { opcoes: opcoes, subtotal: subtotal, cep: d, viaCarrinho: true };
    });
  }

  // ---------- Desenho do resultado (mesma lista na página do produto e na gaveta) ----------
  function desenhar(resultado, nota) {
    if (!resultado.opcoes.length) {
      return '<p class="ng-frete__erro">Não encontramos entrega para este CEP. Confira os números.</p>';
    }
    var html = '<ul class="ng-frete__lista">';
    resultado.opcoes.forEach(function (o) {
      var preco = o.gratis
        ? '<s class="ng-frete__original">' + dinheiro(o.original) + '</s> <span class="ng-frete__preco is-gratis">Grátis</span>'
        : (o.centavos === 0 ? '<span class="ng-frete__preco is-gratis">Grátis</span>' : '<span class="ng-frete__preco">' + dinheiro(o.centavos) + '</span>');
      html += '<li class="ng-frete__opcao"><span class="ng-frete__info"><span class="ng-frete__nome">' + escapar(o.nome) + '</span>' +
        (o.prazo ? '<span class="ng-frete__prazo">' + escapar(o.prazo) + '</span>' : '') +
        '</span><span class="ng-frete__valor">' + preco + '</span></li>';
    });
    html += '</ul>';
    html += '<p class="ng-frete__onde">CEP ' + mascara(resultado.cep) + (nota ? ' · ' + escapar(nota) : '') + '</p>';
    return html;
  }

  // A opção mais barata (depois do desconto de frete): é a que o checkout abre marcada.
  function maisBarata(resultado) {
    if (!resultado || !resultado.opcoes || !resultado.opcoes.length) return null;
    return resultado.opcoes.reduce(function (m, o) { return o.centavos < m.centavos ? o : m; });
  }
  // Resumo de uma linha ("Grátis" / "a partir de R$ 9,90").
  function resumo(resultado) {
    var menor = maisBarata(resultado);
    if (!menor) return '';
    return menor.centavos === 0 ? 'Grátis' : 'a partir de ' + dinheiro(menor.centavos);
  }

  window.NaguirreFrete = {
    cotar: cotar,
    cotarPeloCarrinho: cotarPeloCarrinho,
    lerCarrinho: lerCarrinho,
    gravarCepNoCarrinho: gravarCepNoCarrinho,
    desenhar: desenhar,
    resumo: resumo,
    maisBarata: maisBarata,
    marcarCalculou: marcarCalculou,
    jaCalculou: jaCalculou,
    soDigitos: soDigitos,
    mascara: mascara,
    ufDoCep: ufDoCep,
    lerCep: lerCep,
    gravarCep: gravarCep,
    dinheiro: dinheiro,
    escapar: escapar
  };

  // ---------- Página do produto: bloco "Calcular frete e prazo" ----------
  function iniciarBloco(bloco) {
    if (bloco.__ngFrete) return;
    bloco.__ngFrete = true;
    var campo = bloco.querySelector('[data-ng-cep]');
    var botao = bloco.querySelector('[data-ng-calcular]');
    var alvo = bloco.querySelector('[data-ng-frete-resultado]');
    var gratisMin = parseInt(bloco.getAttribute('data-gratis-min'), 10) || 0;
    var gratisTeto = parseInt(bloco.getAttribute('data-gratis-teto'), 10) || 0;
    var formId = bloco.getAttribute('data-form');
    var vez = 0;
    var ultimoCep = '';

    function formulario() {
      return (formId && document.getElementById(formId)) || document.querySelector('form[data-type="add-to-cart-form"]');
    }
    function pecaAtual() {
      var f = formulario();
      var id = f && f.querySelector('[name="id"]');
      var qtd = f && f.querySelector('[name="quantity"]');
      return { id: id && parseInt(id.value, 10), quantidade: Math.max(1, parseInt(qtd && qtd.value, 10) || 1) };
    }

    function calcular(silencioso) {
      var cep = campo.value;
      if (soDigitos(cep).length !== 8) {
        if (!silencioso) alvo.innerHTML = '<p class="ng-frete__erro">Digite os 8 números do CEP.</p>';
        return;
      }
      var minha = ++vez;
      ultimoCep = cep;
      if (!silencioso) alvo.innerHTML = '<p class="ng-frete__aviso">Calculando…</p>';
      botao.disabled = true;
      var peca = pecaAtual();
      lerCarrinho().catch(function () { return { linhas: [], codigos: [], semSacola: true }; }).then(function (sacola) {
        var naSacola = sacola.linhas.reduce(function (t, l) { return t + l.quantidade; }, 0);
        return cotar({ linhas: sacola.linhas.concat([peca]), cep: cep, codigos: sacola.codigos, gratisMin: gratisMin, gratisTeto: gratisTeto })
          .then(function (resultado) {
            if (minha !== vez) return;
            gravarCep(cep);
            if (!silencioso) marcarCalculou();
            if (sacola.itens > 0) gravarCepNoCarrinho(cep);
            var nota = sacola.semSacola ? 'valores só desta peça'
              : naSacola > 0 ? 'esta peça + ' + naSacola + (naSacola === 1 ? ' item da sua sacola' : ' itens da sua sacola')
              : 'mesmos valores do checkout';
            alvo.innerHTML = desenhar(resultado, nota);
          });
      }).catch(function (e) {
        if (minha !== vez) return;
        alvo.innerHTML = '<p class="ng-frete__erro">' + escapar((e && e.message) || 'Não foi possível calcular agora. Tente de novo em instantes.') + '</p>';
      }).then(function () { if (minha === vez) botao.disabled = false; });
    }

    campo.addEventListener('input', function () { campo.value = mascara(campo.value); });
    campo.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); calcular(false); } // sem <form>: Enter nunca envia o formulário do produto
    });
    botao.addEventListener('click', function (ev) { ev.preventDefault(); calcular(false); });

    // Trocou tamanho/cor ou quantidade depois de calcular: refaz a conta com a peça nova.
    var f = formulario();
    if (f) {
      var espera = null;
      f.addEventListener('change', function () {
        if (!ultimoCep || !alvo.querySelector('.ng-frete__lista')) return;
        clearTimeout(espera);
        espera = setTimeout(function () { calcular(true); }, 400);
      });
    }

    var salvo = lerCep();
    if (salvo && !campo.value) campo.value = mascara(salvo);
  }

  function iniciarBlocos() {
    var blocos = document.querySelectorAll('[data-ng-frete-pdp]');
    for (var i = 0; i < blocos.length; i++) iniciarBloco(blocos[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarBlocos);
  else iniciarBlocos();
})();
